import {LEGACY_ROUTES} from './regions.mjs';

// Legacy talisman routes predate regional discovery. Regional unlocks apply to every entry point.
export function itemTravelReason(player,target,known,now,readyAt=0){
 if(!player)return 'เชื่อมต่อก่อนเดินทาง';
 if(!known)return 'ไม่มีปลายทางนี้';
 if(target===player.mapId)return 'อยู่ที่นี่แล้ว';
 if((player.hp??0)<=0)return 'ฟื้นตัวก่อนเดินทาง';
 if((player.height??0)>35)return 'ยืนบนพื้นก่อนเดินทาง';
 if((player.inventory?.['warp-talisman']??0)<1)return 'ยันต์ข้ามแดนหมด';
 if(readyAt>now)return 'รอ 3 วินาทีก่อนใช้ซ้ำ';
 if(target==='laplae-town'&&!player.journey?.laplaeOath)return 'ต้องทำคำสัตย์เมืองลับแล';
 if(!Object.hasOwn(LEGACY_ROUTES,target)&&!player.journey?.discovered.includes(target))return 'ต้องสำรวจปลายทางนี้ก่อน';
 return '';
}
